/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ prefix: NonNullable<unknown>, lastIndex: NonNullable<unknown> }} Image_Export_Summary_PrefixInputs */

const en_image_export_summary_prefix = /** @type {(inputs: Image_Export_Summary_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prefix: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
};

const fr_image_export_summary_prefix = /** @type {(inputs: Image_Export_Summary_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prefixe : ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
};

const de_image_export_summary_prefix = /** @type {(inputs: Image_Export_Summary_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Präfix: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
};

const it_image_export_summary_prefix = /** @type {(inputs: Image_Export_Summary_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prefisso: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
};

const ru_image_export_summary_prefix = /** @type {(inputs: Image_Export_Summary_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Префикс: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
};

const es_image_export_summary_prefix = /** @type {(inputs: Image_Export_Summary_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prefijo: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
};

const zh_cn2_image_export_summary_prefix = /** @type {(inputs: Image_Export_Summary_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`前缀：${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
};

const ja_image_export_summary_prefix = /** @type {(inputs: Image_Export_Summary_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プレフィックス: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
};

const hi_image_export_summary_prefix = /** @type {(inputs: Image_Export_Summary_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उपसर्ग: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
};

const pt_pt2_image_export_summary_prefix = /** @type {(inputs: Image_Export_Summary_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prefixo: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
};

/**
* | output |
* | --- |
* | "Prefix: {prefix}0001.png → {prefix}{lastIndex}.png" |
*
* @param {Image_Export_Summary_PrefixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_summary_prefix = /** @type {((inputs: Image_Export_Summary_PrefixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Summary_PrefixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_summary_prefix(inputs)
	if (locale === "de") return de_image_export_summary_prefix(inputs)
	if (locale === "it") return it_image_export_summary_prefix(inputs)
	if (locale === "ru") return ru_image_export_summary_prefix(inputs)
	if (locale === "es") return es_image_export_summary_prefix(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_summary_prefix(inputs)
	if (locale === "ja") return ja_image_export_summary_prefix(inputs)
	if (locale === "hi") return hi_image_export_summary_prefix(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_summary_prefix(inputs)
	return en_image_export_summary_prefix(inputs)
});